import React from 'react';

import { Mutation } from '@apollo/client/react/components';
import { faCalendar, faFlag, faLocationDot, faPenToSquare, faTrashCan } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Alert, Box, Button, Divider, List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import dayjs from 'dayjs';

import signatureGQLSchemas from '../../../../../services/signatures/gqlSchema';

const CandidateCardContractPending = ({ contact, dataSignaturesByContact }) => {
  const contactId = contact.id;
  const contactInfo = contact.contactsInfos[0];

  const onClickDeleteSignature = async (id, deleteSignatureFn) => {
    if (window.confirm('Êtes-vous sûr(e) de vouloir supprimer ce contrat ?\nCette action est irréversible.')) {
      await deleteSignatureFn({ variables: { id } });
    }
  };

  return (
    <>
      <Alert severity='info'>Un contrat est en attente de signature</Alert>
      <List>
        <Box>
          <ListItem sx={{ alignItems: 'flex-start' }}>
            <ListItemIcon sx={{ minWidth: 'auto', marginRight: '10px' }}>
              <FontAwesomeIcon icon={faCalendar} />
            </ListItemIcon>
            <ListItemText
              primary={
                <>
                  <Box component='span'>Date de naissance : </Box>
                  <strong>{dayjs(contactInfo.birth_date).format('DD/MM/YYYY')}</strong>
                </>
              }
            />
          </ListItem>
          <Divider />
          <ListItem sx={{ alignItems: 'flex-start' }}>
            <ListItemIcon sx={{ minWidth: 'auto', marginRight: '10px' }}>
              <FontAwesomeIcon icon={faLocationDot} />
            </ListItemIcon>
            <ListItemText
              primary={
                <>
                  <Box component='span'>Lieux de naissance : </Box>
                  <strong>{contactInfo.birth_place}</strong>
                </>
              }
            />
          </ListItem>
          <Divider />
          <ListItem sx={{ alignItems: 'flex-start' }}>
            <ListItemIcon sx={{ minWidth: 'auto', marginRight: '10px' }}>
              <FontAwesomeIcon icon={faFlag} />
            </ListItemIcon>
            <ListItemText
              primary={
                <>
                  <Box component='span'>Nationalité : </Box>
                  <strong>{contactInfo.nationality}</strong>
                </>
              }
            />
          </ListItem>
        </Box>
      </List>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Button variant='outlined' color='info' href={dataSignaturesByContact.signUrl}>
          <FontAwesomeIcon icon={faPenToSquare} />
          <Box variant='span' sx={{ marginLeft: '10px' }}>
            Aller signer ce contrat
          </Box>
        </Button>
        <Mutation
          mutation={signatureGQLSchemas.Mutation.deleteSignature}
          refetchQueries={[
            {
              query: signatureGQLSchemas.Query.signaturesByContact,
              variables: { contactId: contactId, type: 'CANDIDATE' },
            },
          ]}
        >
          {(deleteSignatureFn, { loading, error }) => {
            return (
              <Button
                sx={{ marginLeft: '10px' }}
                variant='contained'
                color='primary'
                onClick={() => onClickDeleteSignature(dataSignaturesByContact.id, deleteSignatureFn)}
              >
                <FontAwesomeIcon icon={faTrashCan} />
                <Box variant='span' sx={{ marginLeft: '10px' }}>
                  Supprimer ce contrat
                </Box>
              </Button>
            );
          }}
        </Mutation>
      </Box>
    </>
  );
};

export default React.memo(CandidateCardContractPending);
